jQuery(document).ready(function ($) {
  const receiverFieldName = 'receiver_office';
  const overwriteFieldName = 'office_overwrite';
  const $receiverOfficeField = $(getFieldIdentifier(receiverFieldName));
  if($receiverOfficeField.length > 0) {
    $receiverOfficeField.each(function() {
      let $thisField = $(this);
      let $form = $thisField.parents('form');
      let $officeField = $form.find(getFieldIdentifier(overwriteFieldName));
      /* sync office field with receiver field on change */
      $officeField.on('change', function(e) {
        $thisField.val($(e.target).val()).change();
      });
    })
  }
});

function getFieldIdentifier(fieldName) {
  return ':input[name="tx_powermail_pi1[field]['+ fieldName +']"]';
}